var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Group } from "@@/Group";
import { observable, makeObservable, action } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
export class ContactDialogState {
    constructor() {
        this.open = false;
        this.reload = true;
        this.dialogsate = new BaseDialogState();
        this.selectedcontactmap = new Map();
        this.selectedContacts = new Set();
        this.groups = [];
        this.loading = false;
        this.loadingmore = false;
        this.showselected = false;
        this.showunselected = false;
        this.filterString = "";
        this.selectedEditGroup = new Set();
        this.letrMembers = new Set();
        makeObservable(this);
        this.dialogsate.setHeaderLabel("Contacts");
        this.dialogsate.setOkLabel("Done");
        this.dialogsate.setCancelLabel("Cancel");
        this.dialogsate.onClose = () => {
            this.resetFilter();
        };
        this.dialogsate.onOk = () => {
            this.dialogsate.setOpen(false);
            this.resetFilter();
        };
    }
    addLetrMember(id) {
        this.letrMembers.add(id);
    }
    setShowSelected() {
        this.setFilterString("");
        this.showselected = true;
        this.showunselected = false;
    }
    setFilterString(input) {
        this.filterString = input;
    }
    setShowUnSelected() {
        this.setFilterString("");
        this.showunselected = true;
        this.showselected = false;
    }
    setShowAllItems() {
        this.setFilterString("");
        this.showselected = false;
        this.showunselected = false;
    }
    resetFilter() {
        this.setFilterString("");
        this.setShowAllItems();
    }
    reset() {
        this.setLoading(false);
        this.setLoadingMore(false);
        this.selectedContacts.clear();
        this.selectedcontactmap.clear();
    }
    resetSelectedContact() {
        var _a;
        this.selectedContacts.clear();
        this.selectedcontactmap.clear();
        (_a = this.onSelecCb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    setOpen(open) {
        if (open && this.reload) {
            this.reload = false;
        }
        this.open = open;
        this.dialogsate.setOpen(open);
    }
    setLoadingMore(loading) {
        this.loadingmore = loading;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    // maybe we should tell other side about this as well
    setSelectedContact(cont) {
        var _a, _b;
        let selection = false;
        if (this.selectedContacts.has(cont.id)) {
            this.selectedContacts.delete(cont.id);
            this.selectedcontactmap.delete(cont.id);
        }
        else {
            this.selectedContacts.add(cont.id);
            this.selectedcontactmap.set(cont.id, cont);
            selection = true;
        }
        (_a = this.onSelecCb) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.onOptionSelectionChanged) === null || _b === void 0 ? void 0 : _b.call(this, selection, cont.id);
    }
    setEditPermForContact(cont) {
        var _a;
        let selection = false;
        if (this.selectedEditGroup.has(cont.id)) {
            this.selectedEditGroup.delete(cont.id);
        }
        else {
            this.selectedEditGroup.add(cont.id);
            selection = true;
        }
        (_a = this.onPermissionSelectionChanged) === null || _a === void 0 ? void 0 : _a.call(this, selection, cont.id);
    }
    getSelectedContact() {
        return Array.from(this.selectedcontactmap.values()).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ContactDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", BaseDialogState)
], ContactDialogState.prototype, "dialogsate", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ContactDialogState.prototype, "selectedcontactmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ContactDialogState.prototype, "selectedContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], ContactDialogState.prototype, "groups", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ContactDialogState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ContactDialogState.prototype, "loadingmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ContactDialogState.prototype, "showselected", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ContactDialogState.prototype, "showunselected", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ContactDialogState.prototype, "filterString", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ContactDialogState.prototype, "selectedEditGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], ContactDialogState.prototype, "letrMembers", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "addLetrMember", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setShowSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setFilterString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setShowUnSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setShowAllItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "resetFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "resetSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], ContactDialogState.prototype, "setEditPermForContact", null);
